import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'

export const About: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 py-8">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{t('about.title')}</h1>
            <p className="text-lg text-gray-600">
              {t('about.subtitle')}
            </p>
          </div>

          {/* Company Section */}
          <div className="mb-12">
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('about.company.title')}</h2>
              <p className="text-gray-700 mb-6">
                {t('about.company.description')}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Mission */}
                <div className="bg-white rounded-lg p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                    <span className="text-2xl mr-2">🎯</span>
                    {t('about.company.mission.title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('about.company.mission.content')}
                  </p>
                </div>

                {/* Vision */}
                <div className="bg-white rounded-lg p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                    <span className="text-2xl mr-2">🚀</span>
                    {t('about.company.vision.title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('about.company.vision.content')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Team Section */}
          <div className="mb-12">
            <div className="bg-gray-50 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="text-3xl mr-3">👥</span>
                {t('about.team.title')}
              </h2>
              <p className="text-gray-700">
                {t('about.team.description')}
              </p>
            </div>
          </div>

          {/* Technology Section */}
          <div className="mb-12">
            <div className="bg-gray-50 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="text-3xl mr-3">🤖</span>
                {t('about.technology.title')}
              </h2>
              <p className="text-gray-700">
                {t('about.technology.description')}
              </p>
            </div>
          </div>

          {/* Company Details Section */}
          <div className="mb-12">
            <div className="bg-white border border-gray-200 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="text-3xl mr-3">🏢</span>
                {t('about.companyDetails.title')}
              </h2>

              <div className="space-y-3">
                <div className="border-b border-gray-100 pb-3">
                  <p className="text-sm text-gray-500 mb-1">Nazwa prawna</p>
                  <p className="text-gray-900 font-medium">
                    {t('about.companyDetails.legalName')}
                  </p>
                </div>

                <div className="border-b border-gray-100 pb-3">
                  <p className="text-sm text-gray-500 mb-1">Siedziba</p>
                  <p className="text-gray-900">
                    {t('about.companyDetails.city')}
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-2">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">NIP</p>
                    <p className="text-gray-900 font-mono">5482683105</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">REGON</p>
                    <p className="text-gray-900 font-mono">367422892</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">KRS</p>
                    <p className="text-gray-900 font-mono">0000674327</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-8 text-white">
            <h2 className="text-2xl font-bold mb-4">{t('about.cta.title')}</h2>
            <p className="mb-6">{t('about.cta.description')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-block bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
              >
                {t('about.cta.contactButton')}
              </a>
              <a
                href="/"
                className="inline-block bg-blue-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-800 transition-colors border-2 border-white"
              >
                {t('about.cta.generatorButton')}
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
